import { createFileRoute } from '@tanstack/react-router'
import { ActivityEditor } from './-ActivityEditor'

export const Route = createFileRoute('/crm/activities/$id')({
  component: ActivityDetailPage,
})

function ActivityDetailPage() {
  const { id } = Route.useParams()
  return <ActivityEditor id={id} />
}
